import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { AlocacaoRoutes } from '../../app/modules/alocacao/routes/alocacao.routes';
import { AutenticacaoRoutes } from '../../app/modules/autenticacao/routes/autenticacao.routes';
import { DisciplinaRoutes } from '../../app/modules/disciplina/routes/disciplina.routes';
import { ProfessorRoutes } from '../../app/modules/professor/routes/professor.routes';
import { ProjetoPedagogicoRoutes } from '../../app/modules/projeto/routes/projeto_pedagogico.routes';
import { FeriadoRoutes } from '../../app/modules/feriado/routes/feriado.routes';
import { InicioRoutes } from '../../app/modules/inicio/routes/inicio.routes';
import { HorarioRoutes } from '../../app/modules/horario/routes/horario.routes';
import { PeriodoRoutes } from '../../app/modules/periodo/routes/periodo.routes';
import { UnidadeRoutes } from '../../app/modules/unidade/routes/unidade.routes';
import { CursoRoutes } from '../../app/modules/curso/routes/curso.routes';
import { Header } from '../../app/modules/shared/components/layout_components/header';

const Routes: React.FC = () => {
  const { autenticado } = useSelector((state: RootState) => state.autenticacao);

  return (
    <BrowserRouter>
      {autenticado && (
        <>
          <Header />
          <InicioRoutes />
          <AlocacaoRoutes />
          <DisciplinaRoutes />
          <ProfessorRoutes />
          <ProjetoPedagogicoRoutes />
          <FeriadoRoutes />
          <HorarioRoutes />
          <PeriodoRoutes />
          <UnidadeRoutes />
          <CursoRoutes />
        </>
      )}
      <AutenticacaoRoutes />
    </BrowserRouter>
  );
};

export { Routes };
